import {
  QueueStatus,
  RawQueueIncident,
} from '@collector/desktop-feature-incidents-queue-core'

import { Tables } from '../tables'
import { getTable } from '../utils'

export type EventIncidentsQueueRecord = {
  eventId: number
  rawQueueIncidents: RawQueueIncident[]
  queueStatus: QueueStatus
}

export async function put(
  eventId: number,
  eventIncidentsQueue: EventIncidentsQueueRecord,
): Promise<void> {
  const table = getTable(Tables.EVENT_INCIDENTS_QUEUE)

  await table.put(eventIncidentsQueue, eventId)
}

export function get(
  eventId: number,
): Promise<EventIncidentsQueueRecord | undefined> {
  const table = getTable(Tables.EVENT_INCIDENTS_QUEUE)

  return table.get(eventId)
}

export function remove(eventId: number): Promise<void> {
  const table = getTable(Tables.EVENT_INCIDENTS_QUEUE)

  return table.delete(eventId)
}
